import { ConfigurationForm } from '../ConfigurationForm'
import { defaultInputs } from './constant'

export const StaticFiles = () => {
  return <ConfigurationForm defaultInputs={defaultInputs()} configurationKey="staticFiles" />
}
